export default __webpack_public_path__ + "static/media/nominate_now.db8dd9e5.png";